import _Alert from "antd/es/alert";
var _excluded = ["className", "icon", "showIcon", "closable", "type"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import OneSymbolIcon from '../OneSymbolIcon';
import cs from 'classnames';
import './index.less';
var iconMap = {
  success: 'icon-iconCheckCircle',
  info: 'icon-iconinfo-circle',
  warning: 'icon-iconExclamationCircle',
  error: 'icon-iconCloseCircle'
};
var OneAlert = function OneAlert(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
    _ref$closable = _ref.closable,
    closable = _ref$closable === void 0 ? true : _ref$closable,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'warning' : _ref$type,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_Alert, _extends({
    type: type,
    className: cs(className, "one-alert-".concat(type)),
    icon: icon || /*#__PURE__*/React.createElement(OneSymbolIcon, {
      style: {
        fontSize: 16
      },
      icon: iconMap[type]
    }),
    showIcon: showIcon,
    closable: closable
  }, rest));
};
OneAlert.ErrorBoundary = _Alert.ErrorBoundary;
export default OneAlert;